import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import { REPORTE_PERIODOS_INFORME_PENSION } from "@constants/informe-pensiones.constants";
import {
  IInformePensionesResponse,
  IReporteDisponibleInformePension,
} from "@shared/common/interfaces/reporte-disponible-informe-pension.interface";
import { Util } from "@shared/common/utils/util";
import { StorageService } from "../../../shared/services/storage/storage.service";
import { InformePensionesService } from "../../services/informe-pensiones.service";
import { IPropiedadesVideoIPPResponse } from "@shared/common/interfaces/video-ipp.interface";
import { ModalService } from "@services/modal/modal.service";
import { ModalVideoIppComponent } from "@shared/components/modal-video-ipp/modal-video-ipp.component";

@Component({
  selector: "app-card-header",
  templateUrl: "./card-header.component.html",
  styleUrl: "./card-header.component.scss",
  standalone: false,
})
export class CardHeaderComponent implements OnInit {
  @Input() isValidateVideoIPP: boolean = false;
  @Input() propiedadesVideo: IPropiedadesVideoIPPResponse | null = null;

  periodos: string[] = [];

  periodoSeleccionado: string = "";

  isOpenDropdown: boolean = false;
  runDownload: boolean = false;
  showMessage: boolean = false;
  state: "success" | "error" = "success";
  title: string = "";

  @ViewChild("periodSelect", { static: true }) periodSelect!: ElementRef;
  @ViewChild("dropdownMenu", { static: true }) dropdownMenu!: ElementRef;
  @ViewChild("selectedPeriod", { static: true }) selectedPeriod!: ElementRef;

  constructor(
    private readonly storageService: StorageService,
    private readonly informePensionesService: InformePensionesService,
    private readonly util: Util,
    private readonly modalService: ModalService
  ) {}

  ngOnInit() {
    void this.initilizeComponent();
  }

  private async initilizeComponent(){
    const periodosDisponibles: IReporteDisponibleInformePension =
          await this.storageService.get(REPORTE_PERIODOS_INFORME_PENSION);
        this.periodos = periodosDisponibles.periodos;
        this.periodoSeleccionado = this.periodos[0];
  }


  openDropdown() {
    if (this.isOpenDropdown) {
      this.closeDropdown();
      this.isOpenDropdown = false;
      return;
    }
    const periodSelect = this.periodSelect.nativeElement;
    const dropdownMenu = this.dropdownMenu.nativeElement;

    dropdownMenu.classList.add("show");
    periodSelect.classList.add("active");

    this.isOpenDropdown = true;
  }

  closeDropdown() {
    const periodSelect = this.periodSelect.nativeElement;
    const dropdownMenu = this.dropdownMenu.nativeElement;
    dropdownMenu.classList.remove("show");
    periodSelect.classList.remove("active");
  }

  selectPeriodo(periodo: string) {
    this.isOpenDropdown = false;
    this.periodoSeleccionado = periodo;
    this.closeDropdown();
  }

  async downloadInforme() {
    try {
      this.runDownload = true;
      const token = await this.util.getIdToken();
      const informeResponse: IInformePensionesResponse =
        await this.informePensionesService.getInformePensiones(
          token,
          this.periodoSeleccionado
        );

      if (informeResponse) {
        const nombreArchivo = this.periodoSeleccionado
          ? `${this.periodoSeleccionado}_Informe_de_Pensiones_Personalizado.pdf`
          : `comprobante_informe-pension.pdf`;
        this.util.downloadFile(
          informeResponse.pdf_base64.toString(),
          nombreArchivo
        );

        this.state = "success";
        this.title = "Tu Informe fue descargado con éxito";
      }
    } catch (error) {
      console.log("Error downloading report:", error);
      this.state = "error";
      this.title = "Ocurrió un error al descargar tu informe";
    } finally {
      this.runDownload = false;
      this.showMessage = true;
    }
  }

  closeMessage() {
    this.showMessage = false;
  }

  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    if (
      this.isOpenDropdown &&
      !this.periodSelect.nativeElement.contains(event.target) &&
      !this.dropdownMenu.nativeElement.contains(event.target)
    ) {
      this.closeDropdown();
      this.isOpenDropdown = false;
    }
  }

  getHeroContentClass(): string {
    return this.isValidateVideoIPP ? "hero-content video-content" : "hero-content";
  }

  getHeroSectionContentClass(): string {
    return this.isValidateVideoIPP ? "hero-section video-hero-section" : "hero-section";
  }

  openVideo(){
    void this.modalService.openCustomModal({
      component: ModalVideoIppComponent,
      cssClass: "modal-video-ipp",
      componentProps: {
        data: this.propiedadesVideo
      }
    });
  }
}
